(function() {
  'use strict';

  var SAVE_NUDGE_THRESHOLD = 3;
  var SS_WISHLIST_KEY = 'swym-wishlist-products';
  var SS_SFL_KEY = 'swym-sfl-products';
  var SS_SHARE_URL_KEY = 'swym-share-url';
  var CARD_SELECTOR = '.product-block--wishlist';
  var DEFAULT_ASPECT_RATIO = 0.8417;
  var productDataCache = Object.create(null);
  var preorderAvailabilityCache = Object.create(null);
  var CHEVRON_LEFT_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-left" aria-hidden="true" focusable="false" role="presentation"><path d="m15 18-6-6 6-6"/></svg>';
  var CHEVRON_RIGHT_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation"><path d="m9 18 6-6-6-6"/></svg>';

  function getPageRoot() {
    return document.getElementById('swym-wishlist-page')
      || document.getElementById('swym-shared-wishlist-page');
  }

  function getPageStrings() {
    var root = getPageRoot();
    return {
      addToCart: (root && root.dataset.addToCart) || 'Add to Cart',
      moveToCart: (root && root.dataset.moveToCart) || 'Move to Bag',
      adding: (root && root.dataset.adding) || 'Adding…',
      added: (root && root.dataset.added) || 'Added!',
      moving: (root && root.dataset.moving) || 'Moving…',
      moved: (root && root.dataset.moved) || 'Moved to bag!',
      error: (root && root.dataset.error) || 'Error',
      outOfStock: (root && root.dataset.outOfStock) || 'Sold out',
      notifyWhenAvailable: (root && root.dataset.notifyWhenAvailable)
        || (window.theme && window.theme.strings && window.theme.strings.notifyWhenAvailable)
        || 'Notify me',
      removeLabel: (root && root.dataset.removeLabel) || 'Remove from wishlist',
      removeSflLabel: (root && root.dataset.removeSflLabel) || 'Remove from saved items',
      removeConfirmTitle: (root && root.dataset.removeConfirmTitle) || 'Remove from wishlist?',
      removeConfirmText: (root && root.dataset.removeConfirmText)
        || 'Are you sure you want to remove “__TITLE__” from your wishlist?',
      removeConfirmSflTitle: (root && root.dataset.removeConfirmSflTitle) || 'Remove from saved items?',
      removeConfirmSflText: (root && root.dataset.removeConfirmSflText)
        || 'Are you sure you want to remove “__TITLE__” from your saved items?',
      removeConfirmCancel: (root && root.dataset.removeConfirmCancel) || 'Cancel',
      removeConfirmAction: (root && root.dataset.removeConfirmAction) || 'Remove',
      sizeLabel: (root && root.dataset.sizeLabel) || 'Size:',
      sliderPrevious: (root && root.dataset.sliderPrevious) || 'Previous',
      sliderNext: (root && root.dataset.sliderNext) || 'Next',
      unavailable: (root && root.dataset.unavailable) || 'No longer available'
    };
  }

  function getAspectRatio() {
    var root = getPageRoot();
    var ratio = root && parseFloat(root.dataset.aspectRatio);
    return ratio > 0 ? ratio : DEFAULT_ASPECT_RATIO;
  }

  function getMoneyFormat(useNoDecimals) {
    var format = (window.theme && window.theme.settings && window.theme.settings.moneyWithCurrencyFormat) || '€{{amount}}';
    if (!useNoDecimals) return format;
    if (/\{\{\s*amount_no_decimals/.test(format)) return format;
    if (format.indexOf('amount_with_comma_separator') !== -1) {
      return format.replace('amount_with_comma_separator', 'amount_no_decimals_with_comma_separator');
    }
    if (format.indexOf('amount_with_apostrophe_separator') !== -1) {
      return format.replace('amount_with_apostrophe_separator', 'amount_no_decimals_with_apostrophe_separator');
    }
    return format.replace('amount', 'amount_no_decimals');
  }

  function getProductPriceCents(product) {
    var raw = product.pr != null ? product.pr : product.price;
    if (raw == null || raw === '') return null;

    var num = typeof raw === 'string'
      ? parseFloat(String(raw).replace(/[^\d.,-]/g, '').replace(',', '.'))
      : Number(raw);
    if (Number.isNaN(num) || num <= 0) return null;

    // Decimal values are major currency units (e.g. 170.00).
    if (!Number.isInteger(num)) {
      return Math.round(num * 100);
    }

    // Shopify-style cents from add-to-wishlist payloads (e.g. 17000 => EUR 170).
    if (num >= 1000) return num;

    // Swym list API often returns major units as integers (e.g. 170 => EUR 170).
    return num * 100;
  }

  function getVariantForSwymProduct(productData, variantId) {
    if (!productData || !Array.isArray(productData.variants)) return null;
    if (variantId) {
      var matched = null;
      productData.variants.some(function(variant) {
        if (String(variant.id) !== String(variantId)) return false;
        matched = variant;
        return true;
      });
      if (matched) return matched;
    }
    return productData.variants[0] || null;
  }

  function resolveVariantPricing(product, productData) {
    var variant = getVariantForSwymProduct(productData, product && product.epi);
    if (variant && variant.price > 0) {
      return {
        price: variant.price,
        compareAt: variant.compare_at_price || 0
      };
    }

    var fallbackPrice = getProductPriceCents(product);
    return {
      price: fallbackPrice,
      compareAt: 0
    };
  }

  function isWishlistProductInStock(product, productData) {
    var variant = getVariantForSwymProduct(productData, product && product.epi);
    if (variant && typeof variant.available === 'boolean') {
      return variant.available;
    }
    if (productData && productData.available === false) return false;
    return product.stk !== 0;
  }

  function getWishlistProductUrl(productUrl, variantId) {
    if (!productUrl || productUrl === '#') return productUrl;
    if (!variantId) return productUrl;

    try {
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', String(variantId));
      return url.pathname + url.search + url.hash;
    } catch (e) {
      var joiner = productUrl.indexOf('?') !== -1 ? '&' : '?';
      return productUrl + joiner + 'variant=' + encodeURIComponent(variantId);
    }
  }

  function createMoneyValueSpan(cents) {
    var valueSpan = document.createElement('span');
    valueSpan.className = 'js-value theme-money';
    valueSpan.setAttribute('data-cc-cents', String(cents));
    valueSpan.textContent = formatMoney(cents);
    return valueSpan;
  }

  function refreshWishlistPriceCurrency(priceWrap) {
    if (!priceWrap || !window.aesthetCurrency || typeof window.aesthetCurrency.refreshEl !== 'function') return;
    requestAnimationFrame(function() {
      priceWrap.querySelectorAll('.js-value[data-cc-cents]').forEach(function(el) {
        window.aesthetCurrency.refreshEl(el);
      });
    });
  }

  function buildWishlistPriceWrap(product, productData) {
    var pricing = resolveVariantPricing(product, productData);
    if (!pricing.price) return null;

    var isOnSale = pricing.compareAt > pricing.price;
    var priceWrap = document.createElement('div');
    priceWrap.className = 'product-price product-price--block';

    var priceEl = document.createElement('div');
    priceEl.className = 'price price--stacked-sale' + (isOnSale ? ' price--on-sale' : ' price--stacked-sale-row-reserved');

    var priceDefault = document.createElement('div');
    priceDefault.className = 'price__default';

    var rowCurrent = document.createElement('div');
    rowCurrent.className = 'price__row price__row--current';

    var priceCurrent = document.createElement('span');
    priceCurrent.className = 'price__current';
    priceCurrent.appendChild(createMoneyValueSpan(pricing.price));
    rowCurrent.appendChild(priceCurrent);
    priceDefault.appendChild(rowCurrent);

    var rowWas = document.createElement('div');
    rowWas.className = 'price__row price__row--was' + (isOnSale ? '' : ' price__row--was-placeholder');
    if (!isOnSale) rowWas.setAttribute('aria-hidden', 'true');

    var priceWas = document.createElement('span');
    priceWas.className = 'price__was';
    if (isOnSale) {
      priceWas.appendChild(createMoneyValueSpan(pricing.compareAt));
    } else {
      var wasPlaceholder = document.createElement('span');
      wasPlaceholder.className = 'js-value';
      wasPlaceholder.textContent = '\u00a0';
      priceWas.appendChild(wasPlaceholder);
    }
    rowWas.appendChild(priceWas);

    var discountEl = document.createElement('span');
    discountEl.className = 'price__discount-percent';
    if (isOnSale) {
      var discountPercent = Math.round(((pricing.compareAt - pricing.price) * 100) / pricing.compareAt);
      discountEl.textContent = '-' + discountPercent + '%';
    } else {
      discountEl.textContent = '\u00a0';
    }
    rowWas.appendChild(discountEl);
    priceDefault.appendChild(rowWas);

    priceEl.appendChild(priceDefault);
    priceWrap.appendChild(priceEl);
    refreshWishlistPriceCurrency(priceWrap);
    return priceWrap;
  }

  function formatMoney(priceInCents) {
    var value = priceInCents;
    if (typeof value === 'string') value = parseInt(value.replace('.', ''), 10);
    if (Number.isNaN(value)) return '';

    var moneyFormat = getMoneyFormat(true);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatMatch = moneyFormat.match(placeholderRegex);
    var placeholder = formatMatch ? formatMatch[1] : 'amount';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var p = precision == null ? 0 : precision;
      var t = thousands == null ? '.' : thousands;
      var dec = decimal == null ? ',' : decimal;
      if (Number.isNaN(number) || number == null) return '0';
      var n = (number / 100.0).toFixed(p);
      var parts = n.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return intPart + (parts[1] ? dec + parts[1] : '');
    }

    var formatted;
    switch (placeholder) {
      case 'amount':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatWithDelimiters(value, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        formatted = formatWithDelimiters(value, 0, "'", '.');
        break;
      default:
        formatted = formatWithDelimiters(value, 0, '.', ',');
    }

    return moneyFormat.replace(placeholderRegex, formatted).replace(/\s*EUR\s*$/i, '');
  }

  function parseProductMeta(product) {
    var fullTitle = (product.dt || 'Product').trim();
    var vendorHint = (product.bt || product.vendor || '').trim();
    var variantLabel = getVariantLabel(product);
    var vendor = vendorHint;
    var title = fullTitle;

    if (vendorHint && fullTitle.indexOf(' | ') !== -1) {
      var parts = fullTitle.split(' | ');
      var firstSegment = parts[0].trim();
      var rest = parts.slice(1).join(' | ').trim();

      if (rest && firstSegment === vendorHint) {
        vendor = vendorHint;
        title = rest;
      }
    }

    return { vendor: vendor, title: title, variantLabel: variantLabel };
  }

  function getVariantLabel(product) {
    var label = (product.vi || product.variantTitle || product.variant || '').trim();
    if (!label) return '';
    if (/^default\s*title$/i.test(label)) return '';
    return label;
  }

  function extractProductHandle(productUrl) {
    if (!productUrl) return '';
    try {
      var path = new URL(productUrl, window.location.origin).pathname;
      var parts = path.split('/').filter(Boolean);
      var productsIndex = parts.indexOf('products');
      if (productsIndex !== -1 && parts[productsIndex + 1]) {
        return parts[productsIndex + 1];
      }
    } catch (e) { /* fall through */ }
    var segments = String(productUrl).split('?')[0].split('/').filter(Boolean);
    return segments.length ? segments[segments.length - 1] : '';
  }

  function fetchProductData(handle) {
    if (!handle) {
      return Promise.resolve({ productData: null, storefrontStatus: 'unavailable' });
    }
    if (productDataCache[handle]) return Promise.resolve(productDataCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(res) {
        if (res.ok) {
          return res.json().then(function(data) {
            var result = { productData: data, storefrontStatus: 'ok' };
            productDataCache[handle] = result;
            return result;
          });
        }
        if (res.status === 404 || res.status === 410) {
          var unavailable = { productData: null, storefrontStatus: 'unavailable' };
          productDataCache[handle] = unavailable;
          return unavailable;
        }
        return { productData: null, storefrontStatus: 'unknown' };
      })
      .catch(function() {
        return { productData: null, storefrontStatus: 'unknown' };
      });
  }

  function fetchPreorderAvailability(handle) {
    if (!handle) return Promise.resolve(false);
    if (preorderAvailabilityCache[handle] !== undefined) {
      return Promise.resolve(preorderAvailabilityCache[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '?sections=product-preorder-flag')
      .then(function(res) {
        if (!res.ok) throw new Error('Preorder flag unavailable');
        return res.json();
      })
      .then(function(data) {
        var html = data.sections && data.sections['product-preorder-flag'];
        var isPreorder = !!(html && String(html).indexOf('true') !== -1);
        preorderAvailabilityCache[handle] = isPreorder;
        return isPreorder;
      })
      .catch(function() {
        preorderAvailabilityCache[handle] = false;
        return false;
      });
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.pathname = parsed.pathname
        .replace(/_\d+x\d+(?=\.[^./]+$)/i, '')
        .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x(?:@2x)?)(?=\.[^./]+$)/i, '');
      return parsed.origin + parsed.pathname;
    } catch (e) {
      return String(url).split('?')[0]
        .replace(/_\d+x\d+(?=\.[^./]+$)/i, '')
        .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x(?:@2x)?)(?=\.[^./]+$)/i, '');
    }
  }

  function getGalleryImageUrls(productData, variantId, fallbackUrl) {
    var urls = [];
    var seen = Object.create(null);

    function add(url) {
      var key = normalizeImageUrl(url);
      if (!key || seen[key]) return;
      seen[key] = true;
      urls.push(url);
    }

    if (variantId && productData && productData.variants) {
      productData.variants.some(function(variant) {
        if (String(variant.id) !== String(variantId)) return false;
        if (variant.featured_image && variant.featured_image.src) {
          add(variant.featured_image.src);
        }
        return true;
      });
    }

    (productData && productData.images || []).forEach(add);

    if (urls.length === 0 && fallbackUrl) {
      add(fallbackUrl);
    }

    return urls;
  }

  function createWishlistImageSlide(url, alt, aspectRatio, extraClass, loading) {
    var slide = document.createElement('div');
    slide.className = 'product-block__image ' + (extraClass || '');

    var imgAr = document.createElement('div');
    imgAr.className = 'img-ar img-ar--cover';
    imgAr.style.setProperty('--aspect-ratio', String(aspectRatio));

    var img = document.createElement('img');
    img.src = url;
    img.alt = alt;
    img.loading = loading || 'lazy';
    img.className = 'theme-img';
    imgAr.appendChild(img);
    slide.appendChild(imgAr);
    return slide;
  }

  function createWishlistImageDots(count) {
    var dots = document.createElement('div');
    dots.className = 'product-block__image-dots';
    dots.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < count; i += 1) {
      var dot = document.createElement('div');
      dot.className = 'product-block__image-dot' + (i === 0 ? ' product-block__image-dot--active' : '');
      dots.appendChild(dot);
    }

    return dots;
  }

  function createWishlistImageNavButton(direction, label) {
    var btn = document.createElement('a');
    btn.className = 'image-page-button image-page-button--' + direction + ' has-ltr-icon';
    btn.href = '#';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('tabindex', '-1');
    btn.innerHTML = direction === 'previous' ? CHEVRON_LEFT_SVG : CHEVRON_RIGHT_SVG;
    return btn;
  }

  function applyProductGallery(card, productData, swymProduct, meta, aspectRatio, strings) {
    var imageUrls = getGalleryImageUrls(productData, swymProduct.epi, swymProduct.iu);
    if (imageUrls.length <= 1) return false;

    var imageCont = card.querySelector('.image-cont');
    var imageLabelWrap = imageCont && imageCont.querySelector('.image-label-wrap');
    var imageStack = imageLabelWrap && (imageLabelWrap.querySelector(':scope > div') || imageLabelWrap.firstElementChild);
    if (!imageCont || !imageLabelWrap || !imageStack) return false;

    imageCont.classList.add('image-cont--with-secondary-image');
    imageStack.innerHTML = '';

    imageUrls.forEach(function(url, index) {
      var extraClass = index === 0
        ? 'product-block__image--primary product-block__image--active'
        : 'product-block__image--secondary';
      if (index === 1) {
        extraClass += ' product-block__image--show-on-hover product-block__image--inactivated';
      } else if (index > 1) {
        extraClass += ' product-block__image--inactivated';
      }
      imageStack.appendChild(createWishlistImageSlide(url, meta.title, aspectRatio, extraClass, index === 0 ? 'lazy' : 'lazy'));
    });

    var existingDots = imageLabelWrap.querySelector('.product-block__image-dots');
    if (existingDots) existingDots.remove();
    imageLabelWrap.appendChild(createWishlistImageDots(imageUrls.length));

    imageCont.querySelectorAll('.image-page-button').forEach(function(btn) {
      btn.remove();
    });
    imageCont.appendChild(createWishlistImageNavButton('previous', strings.sliderPrevious));
    imageCont.appendChild(createWishlistImageNavButton('next', strings.sliderNext));

    return true;
  }

  function buildWishlistCard(options) {
    var swat = options.swat;
    var mode = options.mode;
    var product = options.product;
    var productData = options.productData;
    var isPreorderAvailability = !!options.isPreorderAvailability;
    var strings = options.strings;
    var aspectRatio = options.aspectRatio;
    var textAlignClass = options.textAlignClass;
    var isSfl = options.mode === 'sfl';
    var isShared = options.mode === 'shared';
    var isUnavailable = !!options.isUnavailable;
    var sflLid = options.sflLid;
    var container = options.container;
    var emptyEl = options.emptyEl;
    var onProductsChange = options.onProductsChange;

    var meta = parseProductMeta(product);
    var productUrl = product.du || '#';
    var pdpUrl = getWishlistProductUrl(productUrl, product.epi);
    var inStock = !isUnavailable && isWishlistProductInStock(product, productData);
    var showAddToCart = !isUnavailable && (inStock || isPreorderAvailability);
    var qty = parseInt(product.qty || product.quantity, 10);
    if (Number.isNaN(qty) || qty < 1) qty = 1;

    var card = document.createElement('product-block');
    card.className = 'product-block product-block--wishlist swym-wishlist-card';
    if (isUnavailable) card.classList.add('product-block--wishlist-unavailable');
    if (product.empi) card.setAttribute('data-product-id', product.empi);
    card.setAttribute('data-swym-mode', mode);
    if (isUnavailable) card.setAttribute('data-unavailable', 'true');

    var productHandle = extractProductHandle(productUrl);
    if (productHandle) card.setAttribute('data-product-handle', productHandle);

    var blockInner = document.createElement('div');
    blockInner.className = 'block-inner';

    var blockInnerInner = document.createElement('div');
    blockInnerInner.className = 'block-inner-inner';

    var imageCont = document.createElement('div');
    imageCont.className = 'image-cont';

    var imageLink = document.createElement(isUnavailable ? 'div' : 'a');
    imageLink.className = 'product-link';
    if (!isUnavailable) imageLink.href = productUrl;
    imageLink.setAttribute('aria-hidden', 'true');
    if (!isUnavailable) imageLink.setAttribute('tabindex', '-1');

    var imageLabelWrap = document.createElement('div');
    imageLabelWrap.className = 'image-label-wrap';

    var imageStack = document.createElement('div');

    var imagePrimary = document.createElement('div');
    imagePrimary.className = 'product-block__image product-block__image--primary product-block__image--active';

    var imgAr = document.createElement('div');
    imgAr.className = 'img-ar img-ar--cover';
    imgAr.style.setProperty('--aspect-ratio', String(aspectRatio));

    var img = document.createElement('img');
    img.src = product.iu || '';
    img.alt = meta.title;
    img.loading = 'lazy';
    img.className = 'theme-img';
    imgAr.appendChild(img);
    imagePrimary.appendChild(imgAr);
    imageStack.appendChild(imagePrimary);
    imageLabelWrap.appendChild(imageStack);
    imageLink.appendChild(imageLabelWrap);
    imageCont.appendChild(imageLink);

    if (!isShared) {
      var removeLabel = isSfl ? strings.removeSflLabel : strings.removeLabel;
      var heartBtn = document.createElement('button');
      heartBtn.type = 'button';
      heartBtn.className = 'swym-wishlist-page-heart';
      heartBtn.setAttribute('aria-pressed', 'true');
      heartBtn.setAttribute('aria-label', removeLabel + ' ' + meta.title);
      heartBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path class="swym-wishlist-page-heart__path" vector-effect="non-scaling-stroke" d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z" stroke="#84714c" stroke-width="1.5" fill="#84714c" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      heartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        confirmRemoveProduct(swat, mode, product, sflLid, card, container, emptyEl, onProductsChange, heartBtn, meta.title);
      });
      imageCont.appendChild(heartBtn);
    }

    var detail = document.createElement('div');
    detail.className = 'product-block__detail ' + textAlignClass;

    var inner = document.createElement('div');
    inner.className = 'inner';

    var detailDefault = document.createElement('div');
    detailDefault.className = 'product-block__detail-default';

    var detailLink = document.createElement(isUnavailable ? 'div' : 'a');
    detailLink.className = 'product-link';
    if (!isUnavailable) detailLink.href = productUrl;

    if (meta.vendor) {
      var vendorEl = document.createElement('div');
      vendorEl.className = 'vendor';
      vendorEl.textContent = meta.vendor;
      detailLink.appendChild(vendorEl);
    }

    var titleEl = document.createElement('div');
    titleEl.className = 'product-block__title';
    titleEl.textContent = meta.title;
    detailLink.appendChild(titleEl);

    var variantEl = document.createElement('div');
    variantEl.className = 'swym-wishlist-page__variant';
    if (meta.variantLabel) {
      variantEl.textContent = strings.sizeLabel + ' ' + meta.variantLabel;
    } else {
      variantEl.classList.add('swym-wishlist-page__variant--empty');
      variantEl.setAttribute('aria-hidden', 'true');
    }
    detailLink.appendChild(variantEl);

    detailDefault.appendChild(detailLink);

    var footer = document.createElement('div');
    footer.className = 'swym-wishlist-page__detail-footer';

    var priceWrap = isUnavailable ? null : buildWishlistPriceWrap(product, productData);
    if (priceWrap) footer.appendChild(priceWrap);

    var actions = document.createElement('div');
    actions.className = 'swym-wishlist-card-actions';

    if (isUnavailable) {
      var unavailableEl = document.createElement('p');
      unavailableEl.className = 'swym-wishlist-unavailable-msg';
      unavailableEl.setAttribute('role', 'status');
      unavailableEl.textContent = strings.unavailable;
      actions.appendChild(unavailableEl);
    } else if (showAddToCart) {
      var actionBtn = document.createElement('button');
      actionBtn.type = 'button';
      actionBtn.className = 'btn btn--brand btn--large add-to-cart swym-wishlist-add-to-cart';
      actionBtn.textContent = strings.addToCart;
      actionBtn.setAttribute('aria-label', strings.addToCart + ' ' + meta.title);
      actionBtn.addEventListener('click', function() {
        if (isSfl) {
          handleMoveToCart(swat, product, sflLid, qty, actionBtn, meta.title, card, container, emptyEl, onProductsChange);
        } else {
          handleAddToCart(product, actionBtn, meta.title);
        }
      });
      actions.appendChild(actionBtn);
    } else {
      var notifyLink = document.createElement('a');
      notifyLink.className = 'btn btn--secondary btn--large swym-wishlist-notify-me';
      notifyLink.href = pdpUrl;
      notifyLink.textContent = strings.notifyWhenAvailable;
      notifyLink.setAttribute('aria-label', strings.notifyWhenAvailable + ' ' + meta.title);
      actions.appendChild(notifyLink);
    }
    footer.appendChild(actions);
    inner.appendChild(detailDefault);
    detail.appendChild(inner);
    detail.appendChild(footer);

    blockInnerInner.appendChild(imageCont);
    blockInnerInner.appendChild(detail);
    blockInner.appendChild(blockInnerInner);
    card.appendChild(blockInner);

    if (productData && !isUnavailable) {
      applyProductGallery(card, productData, product, meta, aspectRatio, strings);
    }

    return card;
  }

  function normalizeProductList(payload) {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.items)) return payload.items;
    if (payload.list && Array.isArray(payload.list.listcontents)) return payload.list.listcontents;
    if (Array.isArray(payload.listcontents)) return payload.listcontents;
    return [];
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute('hidden', '');
      el.style.display = 'none';
    } else {
      el.removeAttribute('hidden');
      el.style.display = '';
    }
  }

  function formatSectionCount(count) {
    return '(' + count + ')';
  }

  function updateSectionCount(el, count) {
    if (!el) return;
    if (count > 0) {
      el.textContent = formatSectionCount(count);
      setHidden(el, false);
    } else {
      el.textContent = '';
      setHidden(el, true);
    }
  }

  function getSectionEls(section) {
    if (section === 'sfl') {
      return {
        section: document.getElementById('swym-section-sfl'),
        loading: document.getElementById('swym-sfl-loading'),
        empty: document.getElementById('swym-sfl-empty'),
        grid: document.getElementById('swym-sfl-grid')
      };
    }
    return {
      section: document.getElementById('swym-section-wishlist'),
      loading: document.getElementById('swym-wishlist-loading'),
      empty: document.getElementById('swym-wishlist-empty'),
      grid: document.getElementById('swym-wishlist-grid')
    };
  }

  function initWishlistPage(swat) {
    var wishlistGrid = document.getElementById('swym-wishlist-grid');
    var sflGrid = document.getElementById('swym-sfl-grid');
    if (!wishlistGrid || !sflGrid) return;

    var pageState = {
      wishlist: { lid: null, products: [], ready: false },
      sfl: { lid: null, products: [], ready: false, available: false }
    };

    if (!swat.platform.isLoggedIn()) {
      setHidden(document.getElementById('swym-login-nudge'), false);
    }

    hydrateWishlistFromCache(pageState, swat, wishlistGrid);
    loadWishlist(swat, pageState, wishlistGrid);
    initSaveForLater(swat, pageState, sflGrid);
    bindRemoveConfirmModal();
  }

  function hydrateWishlistFromCache(pageState, swat, wishlistGrid) {
    var cachedRaw = sessionStorage.getItem(SS_WISHLIST_KEY);
    if (!cachedRaw) return;

    try {
      var cachedData = JSON.parse(cachedRaw);
      pageState.wishlist.lid = cachedData.lid;
      pageState.wishlist.products = cachedData.products || [];
      setHidden(getSectionEls('wishlist').loading, true);
      updateSectionCount(document.getElementById('swym-wishlist-section-count'), pageState.wishlist.products.length);
      renderWishlistSection(swat, pageState, wishlistGrid);
      setupShareButton(swat, pageState.wishlist.lid, pageState.wishlist.products.length);
    } catch (e) {
      sessionStorage.removeItem(SS_WISHLIST_KEY);
    }
  }

  function loadWishlist(swat, pageState, wishlistGrid) {
    swat.fetchLists({
      callbackFn: function(lists) {
        var defaultList = lists && lists.length ? lists[0] : null;
        pageState.wishlist.lid = defaultList ? defaultList.lid : null;
        pageState.wishlist.products = defaultList ? (defaultList.listcontents || []) : [];
        pageState.wishlist.ready = true;

        sessionStorage.setItem(SS_WISHLIST_KEY, JSON.stringify({
          lid: pageState.wishlist.lid,
          products: pageState.wishlist.products
        }));

        setHidden(getSectionEls('wishlist').loading, true);
        updateSectionCount(document.getElementById('swym-wishlist-section-count'), pageState.wishlist.products.length);
        showSaveNudge(swat, pageState.wishlist.products.length);
        setupShareButton(swat, pageState.wishlist.lid, pageState.wishlist.products.length);
        sessionStorage.removeItem(SS_SHARE_URL_KEY);
        renderWishlistSection(swat, pageState, wishlistGrid);

        if (swat.evtLayer && !pageState.wishlist.listenerBound) {
          pageState.wishlist.listenerBound = true;
          swat.evtLayer.addEventListener('sw:removedfromwishlist', function() {
            swat.fetch(function(updated) {
              pageState.wishlist.products = updated || [];
              sessionStorage.setItem(SS_WISHLIST_KEY, JSON.stringify({
                lid: pageState.wishlist.lid,
                products: pageState.wishlist.products
              }));
              sessionStorage.removeItem(SS_SHARE_URL_KEY);
              updateSectionCount(document.getElementById('swym-wishlist-section-count'), pageState.wishlist.products.length);
              setupShareButton(swat, pageState.wishlist.lid, pageState.wishlist.products.length);
              renderWishlistSection(swat, pageState, wishlistGrid);
            });
          });
        }
      },
      errorFn: function() {
        pageState.wishlist.ready = true;
        setHidden(getSectionEls('wishlist').loading, true);
        renderWishlistSection(swat, pageState, wishlistGrid);
      }
    });
  }

  function initSaveForLater(swat, pageState, sflGrid) {
    if (!swat.SaveForLater || typeof swat.SaveForLater.init !== 'function') {
      return;
    }

    var sflSection = getSectionEls('sfl');
    setHidden(sflSection.loading, false);

    swat.SaveForLater.init(
      function(response) {
        var lid = response && response.list && response.list.lid;
        if (!lid) {
          setHidden(sflSection.loading, true);
          return;
        }

        pageState.sfl.available = true;
        pageState.sfl.lid = lid;
        setHidden(sflSection.section, false);

        hydrateSflFromCache(pageState, swat, sflGrid);
        refreshSaveForLater(swat, pageState, sflGrid, true);
      },
      function() {
        setHidden(sflSection.loading, true);
      }
    );
  }

  function hydrateSflFromCache(pageState, swat, sflGrid) {
    var cachedRaw = sessionStorage.getItem(SS_SFL_KEY);
    if (!cachedRaw) return;

    try {
      var cachedData = JSON.parse(cachedRaw);
      if (cachedData.lid !== pageState.sfl.lid) return;
      pageState.sfl.products = cachedData.products || [];
      updateSectionCount(document.getElementById('swym-sfl-section-count'), pageState.sfl.products.length);
      setHidden(getSectionEls('sfl').loading, true);
      renderSflSection(swat, pageState, sflGrid);
    } catch (e) {
      sessionStorage.removeItem(SS_SFL_KEY);
    }
  }

  function refreshSaveForLater(swat, pageState, sflGrid, showLoading) {
    if (!pageState.sfl.lid) return;

    var sflSection = getSectionEls('sfl');
    if (showLoading) {
      setHidden(sflSection.loading, false);
    }

    swat.SaveForLater.fetch(
      pageState.sfl.lid,
      function(response) {
        pageState.sfl.products = normalizeProductList(response);
        pageState.sfl.ready = true;

        sessionStorage.setItem(SS_SFL_KEY, JSON.stringify({
          lid: pageState.sfl.lid,
          products: pageState.sfl.products
        }));

        setHidden(sflSection.loading, true);
        updateSectionCount(document.getElementById('swym-sfl-section-count'), pageState.sfl.products.length);
        renderSflSection(swat, pageState, sflGrid);
      },
      function() {
        pageState.sfl.ready = true;
        setHidden(sflSection.loading, true);
        renderSflSection(swat, pageState, sflGrid);
      }
    );
  }

  function renderWishlistSection(swat, pageState, wishlistGrid) {
    var sectionEls = getSectionEls('wishlist');
    renderProductGrid({
      swat: swat,
      mode: 'wishlist',
      products: pageState.wishlist.products,
      container: wishlistGrid,
      emptyEl: sectionEls.empty,
      sflLid: pageState.sfl.lid,
      onProductsChange: function(nextProducts) {
        pageState.wishlist.products = nextProducts;
        sessionStorage.setItem(SS_WISHLIST_KEY, JSON.stringify({
          lid: pageState.wishlist.lid,
          products: nextProducts
        }));
        updateSectionCount(document.getElementById('swym-wishlist-section-count'), nextProducts.length);
        setupShareButton(swat, pageState.wishlist.lid, nextProducts.length);
      }
    });
  }

  function renderSflSection(swat, pageState, sflGrid) {
    if (!pageState.sfl.available) return;

    var sectionEls = getSectionEls('sfl');
    renderProductGrid({
      swat: swat,
      mode: 'sfl',
      products: pageState.sfl.products,
      container: sflGrid,
      emptyEl: sectionEls.empty,
      sflLid: pageState.sfl.lid,
      onProductsChange: function(nextProducts) {
        pageState.sfl.products = nextProducts;
        sessionStorage.setItem(SS_SFL_KEY, JSON.stringify({
          lid: pageState.sfl.lid,
          products: nextProducts
        }));
        updateSectionCount(document.getElementById('swym-sfl-section-count'), nextProducts.length);
      }
    });
  }

  function showSaveNudge(swat, count) {
    if (swat.platform.isLoggedIn()) return;
    if (count < SAVE_NUDGE_THRESHOLD) return;
    if (sessionStorage.getItem('swym-save-nudge-dismissed')) return;

    var nudge = document.getElementById('swym-save-nudge');
    if (!nudge) return;

    var countSpan = document.getElementById('swym-save-nudge-count');
    if (countSpan) countSpan.textContent = count;
    setHidden(nudge, false);

    var dismiss = document.getElementById('swym-save-nudge-dismiss');
    if (dismiss && !dismiss.dataset.bound) {
      dismiss.dataset.bound = 'true';
      dismiss.addEventListener('click', function() {
        setHidden(nudge, true);
        sessionStorage.setItem('swym-save-nudge-dismissed', 'true');
      });
    }
  }

  function renderProductGrid(options) {
    var swat = options.swat;
    var mode = options.mode;
    var products = options.products;
    var container = options.container;
    var emptyEl = options.emptyEl;
    var sflLid = options.sflLid;
    var onProductsChange = options.onProductsChange;

    container.setAttribute('aria-busy', 'true');
    /*
     * Always bump the token first. Empty renders used to skip this, so an
     * in-flight cache hydrate (async product JSON) could finish after a fresh
     * empty fetch and re-append stale cards under “Your wishlist is empty”.
     */
    container._swymRenderToken = (container._swymRenderToken || 0) + 1;
    var renderToken = container._swymRenderToken;
    container.innerHTML = '';

    if (!products || products.length === 0) {
      container._swymProducts = [];
      setHidden(emptyEl, false);
      container.setAttribute('aria-busy', 'false');
      return;
    }

    setHidden(emptyEl, true);
    container._swymProducts = products.slice();

    var strings = getPageStrings();
    var aspectRatio = getAspectRatio();
    var textAlign = (getPageRoot() && getPageRoot().dataset.textAlign) || 'center';
    var textAlignClass = 'align-ltr-' + textAlign;
    var isSfl = mode === 'sfl';

    var productFetchPromises = products.map(function(product) {
      var handle = extractProductHandle(product.du || '');
      return Promise.all([
        fetchProductData(handle),
        handle ? fetchPreorderAvailability(handle) : Promise.resolve(false)
      ]).then(function(results) {
        return {
          productData: results[0].productData,
          storefrontStatus: results[0].storefrontStatus,
          isPreorderAvailability: results[1]
        };
      });
    });

    Promise.all(productFetchPromises).then(function(productFetchResults) {
      if (!container.isConnected) return;
      if (container._swymRenderToken !== renderToken) return;

      products.forEach(function(product, index) {
        var fetchResult = productFetchResults[index] || {};
        container.appendChild(buildWishlistCard({
          swat: swat,
          mode: mode,
          product: product,
          productData: fetchResult.productData,
          isPreorderAvailability: fetchResult.isPreorderAvailability,
          isUnavailable: fetchResult.storefrontStatus === 'unavailable',
          strings: strings,
          aspectRatio: aspectRatio,
          textAlignClass: textAlignClass,
          sflLid: sflLid,
          container: container,
          emptyEl: emptyEl,
          onProductsChange: onProductsChange
        }));
      });

      container.setAttribute('aria-busy', 'false');
    });
  }

  function syncProductsFromDom(sourceProducts, removedProduct) {
    return (sourceProducts || []).filter(function(item) {
      return String(item.epi) !== String(removedProduct.epi) || String(item.empi) !== String(removedProduct.empi);
    });
  }

  var pendingRemoveAction = null;
  var removeConfirmTrigger = null;
  var removeConfirmBound = false;

  function formatRemoveConfirmText(template, title) {
    return String(template || '').replace(/__TITLE__/g, title || '');
  }

  function fillRemoveConfirmCopy(mode, title) {
    var strings = getPageStrings();
    var isSfl = mode === 'sfl';
    var titleEl = document.getElementById('swym-remove-confirm-title');
    var textEl = document.getElementById('swym-remove-confirm-text');
    if (titleEl) titleEl.textContent = isSfl ? strings.removeConfirmSflTitle : strings.removeConfirmTitle;
    if (textEl) {
      textEl.textContent = formatRemoveConfirmText(
        isSfl ? strings.removeConfirmSflText : strings.removeConfirmText,
        title
      );
    }
    var cancelBtn = document.getElementById('swym-remove-confirm-cancel');
    var actionBtn = document.getElementById('swym-remove-confirm-action');
    if (cancelBtn) cancelBtn.textContent = strings.removeConfirmCancel;
    if (actionBtn) actionBtn.textContent = strings.removeConfirmAction;
  }

  function isRemoveConfirmOpen() {
    var modal = document.getElementById('swym-remove-confirm-modal');
    return !!(modal && !modal.hasAttribute('hidden'));
  }

  function handleRemoveConfirmKeydown(e) {
    if (e.key === 'Escape') {
      closeRemoveConfirmModal(false);
      return;
    }
    if (e.key !== 'Tab') return;

    var content = document.getElementById('swym-remove-confirm-content');
    if (!content) return;
    var focusable = Array.prototype.slice.call(
      content.querySelectorAll('button:not([disabled]),[tabindex]:not([tabindex="-1"])')
    ).filter(function(el) { return !el.disabled && el.offsetParent !== null; });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function closeRemoveConfirmModal(confirmed) {
    var modal = document.getElementById('swym-remove-confirm-modal');
    if (modal) setHidden(modal, true);
    document.removeEventListener('keydown', handleRemoveConfirmKeydown);
    unlockShareModalScroll();

    var action = pendingRemoveAction;
    var trigger = removeConfirmTrigger;
    pendingRemoveAction = null;
    removeConfirmTrigger = null;

    if (confirmed && typeof action === 'function') {
      action();
      return;
    }
    if (trigger && document.body.contains(trigger) && typeof trigger.focus === 'function') {
      trigger.focus();
    }
  }

  function bindRemoveConfirmModal() {
    if (removeConfirmBound) return;
    var modal = document.getElementById('swym-remove-confirm-modal');
    if (!modal) return;
    removeConfirmBound = true;

    var closeBtn = document.getElementById('swym-remove-confirm-close');
    var overlay = document.getElementById('swym-remove-confirm-overlay');
    var cancelBtn = document.getElementById('swym-remove-confirm-cancel');
    var actionBtn = document.getElementById('swym-remove-confirm-action');

    if (closeBtn) closeBtn.addEventListener('click', function() { closeRemoveConfirmModal(false); });
    if (overlay) overlay.addEventListener('click', function() { closeRemoveConfirmModal(false); });
    if (cancelBtn) cancelBtn.addEventListener('click', function() { closeRemoveConfirmModal(false); });
    if (actionBtn) actionBtn.addEventListener('click', function() { closeRemoveConfirmModal(true); });
  }

  function confirmRemoveProduct(swat, mode, product, sflLid, card, container, emptyEl, onProductsChange, trigger, title) {
    var strings = getPageStrings();
    var modal = document.getElementById('swym-remove-confirm-modal');

    function doRemove() {
      handleRemoveProduct(swat, mode, product, sflLid, card, container, emptyEl, onProductsChange);
    }

    if (!modal) {
      if (window.confirm(formatRemoveConfirmText(
        mode === 'sfl' ? strings.removeConfirmSflText : strings.removeConfirmText,
        title
      ))) {
        doRemove();
      }
      return;
    }

    bindRemoveConfirmModal();
    if (isRemoveConfirmOpen()) return;

    fillRemoveConfirmCopy(mode, title);
    pendingRemoveAction = doRemove;
    removeConfirmTrigger = trigger;
    setHidden(modal, false);
    lockShareModalScroll();
    document.addEventListener('keydown', handleRemoveConfirmKeydown);

    var cancelBtn = document.getElementById('swym-remove-confirm-cancel');
    if (cancelBtn) cancelBtn.focus();
  }

  function handleRemoveProduct(swat, mode, product, sflLid, card, container, emptyEl, onProductsChange) {
    var payload = { epi: product.epi, empi: product.empi, du: product.du };
    var sourceProducts = (container._swymProducts || []);

    function afterRemove(nextProducts) {
      card.remove();
      container._swymProducts = nextProducts;
      if (nextProducts.length === 0) setHidden(emptyEl, false);
      if (onProductsChange) onProductsChange(nextProducts);
    }

    if (mode === 'sfl') {
      swat.SaveForLater.remove(sflLid, [payload], function() {
        afterRemove(syncProductsFromDom(sourceProducts, product));
      });
      return;
    }

    swat.removeFromWishList(payload, function() {
      afterRemove(syncProductsFromDom(sourceProducts, product));
    });
  }

  function handleAddToCart(product, cartBtn, title) {
    var strings = getPageStrings();
    cartBtn.textContent = strings.adding;
    cartBtn.setAttribute('aria-label', strings.adding + ' ' + title);
    cartBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(product.epi), quantity: 1 }] })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('cart add failed');
      return response.json();
    })
    .then(function(data) {
      /* /cart/add.js with items[] returns { items: [...] }; single-line shape also exists. */
      var line = (data && data.items && data.items[0]) || data || {};
      cartBtn.textContent = strings.added;
      cartBtn.setAttribute('aria-label', title + ' ' + strings.added);
      notifyThemeCartAdded({
        variantId: line.variant_id || Number(product.epi),
        productId: line.product_id || Number(product.empi),
        productTitle: line.product_title || line.title || title,
        triggerEl: cartBtn
      });
      setTimeout(function() {
        cartBtn.textContent = strings.addToCart;
        cartBtn.setAttribute('aria-label', strings.addToCart + ' ' + title);
        cartBtn.disabled = false;
      }, 2000);
    })
    .catch(function() {
      cartBtn.textContent = strings.error;
      cartBtn.setAttribute('aria-label', strings.error + ' ' + title);
      cartBtn.disabled = false;
    });
  }

  function handleMoveToCart(swat, product, sflLid, qty, cartBtn, title, card, container, emptyEl, onProductsChange) {
    var strings = getPageStrings();
    var payload = { epi: product.epi, empi: product.empi, du: product.du };
    var sourceProducts = container._swymProducts || [];

    cartBtn.textContent = strings.moving;
    cartBtn.setAttribute('aria-label', strings.moving + ' ' + title);
    cartBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(product.epi), quantity: qty }] })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('cart add failed');
      return response.json();
    })
    .then(function(data) {
      var line = (data && data.items && data.items[0]) || data || {};
      swat.SaveForLater.remove(sflLid, [payload], function() {
        var nextProducts = syncProductsFromDom(sourceProducts, product);
        container._swymProducts = nextProducts;
        card.remove();
        if (nextProducts.length === 0) setHidden(emptyEl, false);
        if (onProductsChange) onProductsChange(nextProducts);
        notifyThemeCartAdded({
          variantId: line.variant_id || Number(product.epi),
          productId: line.product_id || Number(product.empi),
          productTitle: line.product_title || line.title || title,
          triggerEl: cartBtn
        });
      });
    })
    .catch(function() {
      cartBtn.textContent = strings.error;
      cartBtn.setAttribute('aria-label', strings.error + ' ' + title);
      cartBtn.disabled = false;
    });
  }

  /**
   * Mirror PDP / lookbook / gift-card after-add: refresh cart UI via on:cart:change,
   * then honor theme.settings.afterAddToCart (drawer / notification / cart page).
   */
  function notifyThemeCartAdded(options) {
    var opts = options || {};
    var themeRef = window.theme;
    var settings = themeRef && themeRef.settings;

    if (document.querySelector('.template-cart')) {
      var cartForm = document.querySelector('cart-form');
      if (cartForm && cartForm.enableAjaxUpdate && typeof cartForm.refresh === 'function') {
        cartForm.refresh();
      }
    } else if (settings && settings.afterAddToCart === 'page') {
      window.location.href = (themeRef.routes && themeRef.routes.cart) || '/cart';
      return;
    } else {
      document.dispatchEvent(
        new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
      );
    }

    if (themeRef && typeof themeRef.setCartLastAddedProductId === 'function' && opts.productId) {
      themeRef.setCartLastAddedProductId(opts.productId);
    }

    document.dispatchEvent(
      new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: {
          variantId: opts.variantId,
          productId: opts.productId
        }
      })
    );

    if (!settings) return;

    if (settings.afterAddToCart === 'drawer') {
      var drawer = document.querySelector('.js-cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(opts.triggerEl || null);
      }
    } else if (settings.afterAddToCart === 'notification') {
      var template = document.getElementById('AddedNotification');
      if (template && template.content) {
        var notification = template.content.firstElementChild.cloneNode(true);
        notification.dataset.productTitle = opts.productTitle || '';
        var container = document.querySelector('.pageheader--sticky') || document.body;
        container.appendChild(notification);
      }
    }
  }

  function normalizeSharedWishlistBase(base) {
    if (!base) return window.location.origin + '/pages/swym-share-wishlist';
    if (/^https?:\/\//i.test(base)) return base.replace(/\/+$/, '');
    var path = base.charAt(0) === '/' ? base : '/' + base;
    return window.location.origin + path.replace(/\/+$/, '');
  }

  function getSharedWishlistPageBase() {
    var root = document.getElementById('swym-wishlist-page');
    var body = document.body;
    var raw = (root && root.dataset.sharedWishlistPageUrl)
      || (body && body.dataset.sharedWishlistPageUrl)
      || '/pages/swym-share-wishlist';
    return normalizeSharedWishlistBase(raw);
  }

  function buildSharedWishlistUrl(lid) {
    var base = getSharedWishlistPageBase();
    var joiner = base.indexOf('?') !== -1 ? '&' : '?';
    return base + joiner
      + 'hkey=' + encodeURIComponent(lid)
      + '&lid=' + encodeURIComponent(lid)
      + '&utm_source=swym-Wishlist'
      + '&utm_medium=shared-wishlist'
      + '&utm_campaign=' + encodeURIComponent(lid);
  }

  function normalizeShareUrl(url, lid) {
    if (!url || !lid) return url;
    if (url.indexOf('/apps/swymWishlist/shared') !== -1) {
      return buildSharedWishlistUrl(lid);
    }
    if (!/^https?:\/\//i.test(url)) {
      return buildSharedWishlistUrl(lid);
    }
    return url;
  }

  function bindShareUrlButtons(modal, copyBtn, url, swat, lid) {
    if (copyBtn) {
      copyBtn.disabled = false;
      var freshCopy = copyBtn.cloneNode(true);
      copyBtn.parentNode.replaceChild(freshCopy, copyBtn);
      freshCopy.addEventListener('click', function() { handleCopyLink(url); });
    }
    modal.querySelectorAll('.swym-share-social-btn').forEach(function(socialBtn) {
      var freshSocial = socialBtn.cloneNode(true);
      socialBtn.parentNode.replaceChild(freshSocial, socialBtn);
      freshSocial.addEventListener('click', function() {
        handleSocialShare(swat, lid, freshSocial.dataset.platform, url);
      });
    });
  }

  function setupShareButton(swat, lid, productCount) {
    var btn = document.getElementById('swym-share-btn');
    if (!btn || !lid) return;

    if (productCount === 0) {
      setHidden(btn, true);
      return;
    }
    setHidden(btn, false);

    var fresh = btn.cloneNode(true);
    btn.parentNode.replaceChild(fresh, btn);
    fresh.addEventListener('click', function() {
      openShareModal(swat, lid);
    });
  }

  var shareModalScrollPos = null;
  var shareModalTouchBlock = null;

  function lockShareModalScroll() {
    if (shareModalScrollPos != null) return;

    shareModalScrollPos = window.scrollY;
    document.documentElement.classList.add('swym-share-modal-open');
    document.body.classList.add('swym-share-modal-open');
    document.body.style.top = '-' + shareModalScrollPos + 'px';
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.overflow = 'hidden';

    shareModalTouchBlock = function(evt) {
      var modalContent = document.getElementById('swym-share-modal-content');
      if (modalContent && modalContent.contains(evt.target)) return;
      evt.preventDefault();
    };
    document.addEventListener('touchmove', shareModalTouchBlock, { passive: false });
  }

  function unlockShareModalScroll() {
    if (shareModalScrollPos == null) return;

    if (shareModalTouchBlock) {
      document.removeEventListener('touchmove', shareModalTouchBlock);
      shareModalTouchBlock = null;
    }

    document.documentElement.classList.remove('swym-share-modal-open');
    document.body.classList.remove('swym-share-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';

    window.scrollTo(0, shareModalScrollPos);
    shareModalScrollPos = null;
  }

  function openShareModal(swat, lid) {
    var modal = document.getElementById('swym-share-modal');
    if (!modal) return;

    var nameInput = document.getElementById('swym-share-name-input');
    var emailInput = document.getElementById('swym-share-email-input');
    var noteInput = document.getElementById('swym-share-note-input');
    var copyBtn = document.getElementById('swym-share-copy-btn');
    if (nameInput) nameInput.value = '';
    if (emailInput) emailInput.value = '';
    if (noteInput) noteInput.value = '';
    if (copyBtn) copyBtn.disabled = true;
    modal.querySelectorAll('[id$="-feedback"]').forEach(function(el) { setHidden(el, true); });

    setHidden(modal, false);
    lockShareModalScroll();
    if (nameInput) nameInput.focus();

    var cachedShareUrl = sessionStorage.getItem(SS_SHARE_URL_KEY);
    if (cachedShareUrl) {
      cachedShareUrl = normalizeShareUrl(cachedShareUrl, lid);
      sessionStorage.setItem(SS_SHARE_URL_KEY, cachedShareUrl);
      bindShareUrlButtons(modal, copyBtn, cachedShareUrl, swat, lid);
    } else {
      swat.markListPublic(lid, function() {
        var url = buildSharedWishlistUrl(lid);
        sessionStorage.setItem(SS_SHARE_URL_KEY, url);
        bindShareUrlButtons(modal, copyBtn, url, swat, lid);
      }, function() {
        if (copyBtn) copyBtn.disabled = true;
      });
    }

    var emailBtn = document.getElementById('swym-share-email-btn');
    if (emailBtn) {
      var freshEmail = emailBtn.cloneNode(true);
      emailBtn.parentNode.replaceChild(freshEmail, emailBtn);
      freshEmail.addEventListener('click', function() { handleEmailShare(swat, lid); });
    }

    var closeBtn = document.getElementById('swym-share-modal-close');
    var overlay = document.getElementById('swym-share-modal-overlay');
    if (closeBtn) {
      var freshClose = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(freshClose, closeBtn);
      freshClose.addEventListener('click', closeShareModal);
    }
    if (overlay) {
      var freshOverlay = overlay.cloneNode(true);
      overlay.parentNode.replaceChild(freshOverlay, overlay);
      freshOverlay.addEventListener('click', closeShareModal);
    }
    document.addEventListener('keydown', handleShareModalKeydown);
  }

  function handleShareModalKeydown(e) {
    if (e.key === 'Escape') {
      closeShareModal();
      return;
    }
    if (e.key !== 'Tab') return;

    var modal = document.getElementById('swym-share-modal-content');
    if (!modal) return;
    var focusable = Array.prototype.slice.call(
      modal.querySelectorAll('a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])')
    ).filter(function(el) { return !el.disabled && el.offsetParent !== null; });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function closeShareModal() {
    var modal = document.getElementById('swym-share-modal');
    if (modal) setHidden(modal, true);
    unlockShareModalScroll();
    document.removeEventListener('keydown', handleShareModalKeydown);
    var trigger = document.getElementById('swym-share-btn');
    if (trigger) trigger.focus();
  }

  function handleCopyLink(url) {
    var feedback = document.getElementById('swym-share-copy-feedback');
    var done = function() {
      showModalFeedback(feedback);
      setTimeout(closeShareModal, 800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function() {
        fallbackCopy(url, feedback);
        setTimeout(closeShareModal, 800);
      });
    } else {
      fallbackCopy(url, feedback);
      setTimeout(closeShareModal, 800);
    }
  }

  function handleEmailShare(swat, lid) {
    var nameInput = document.getElementById('swym-share-name-input');
    var emailInput = document.getElementById('swym-share-email-input');
    var noteInput = document.getElementById('swym-share-note-input');
    var emailBtn = document.getElementById('swym-share-email-btn');
    var feedback = document.getElementById('swym-share-email-feedback');
    if (!emailInput) return;

    var email = emailInput.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailInput.focus();
      return;
    }

    if (emailBtn) emailBtn.disabled = true;
    swat.sendListViaEmail({
      toEmailId: email,
      note: noteInput ? noteInput.value.trim() : '',
      fromName: nameInput ? nameInput.value.trim() : '',
      lid: lid
    }, function() {
      if (emailBtn) emailBtn.disabled = false;
      if (nameInput) nameInput.value = '';
      emailInput.value = '';
      if (noteInput) noteInput.value = '';
      showModalFeedback(feedback);
      setTimeout(closeShareModal, 1000);
    }, function() {
      if (emailBtn) emailBtn.disabled = false;
    });
  }

  function getWishlistShareCopy() {
    var root = getPageRoot();
    return {
      title: (root && root.dataset.shareTitle) || 'Share Your Wishlist',
      text: (root && root.dataset.shareText) || 'Check out my wishlist!'
    };
  }

  function canUseInstagramNativeShare() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
  }

  function copyShareUrl(url, feedbackEl, onComplete) {
    var done = function() {
      if (feedbackEl) showModalFeedback(feedbackEl);
      if (onComplete) onComplete();
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function() {
        fallbackCopy(url, feedbackEl);
        if (onComplete) onComplete();
      });
      return;
    }

    fallbackCopy(url, feedbackEl);
    if (onComplete) onComplete();
  }

  function trackInstagramShare(swat, lid) {
    if (typeof swat.shareListSocial === 'function') {
      swat.shareListSocial(lid, '', '', 'instagram', '', function() {});
    }
  }

  function buildInstagramDeepLink(shareUrl) {
    var encoded = encodeURIComponent(shareUrl);
    if (/Android/i.test(navigator.userAgent || '')) {
      // intent:// opens the app when installed; Chrome falls back to instagram.com when not.
      return 'intent://sharesheet?text=' + encoded
        + '#Intent;package=com.instagram.android;scheme=instagram;'
        + 'S.browser_fallback_url=' + encodeURIComponent('https://www.instagram.com/') + ';end';
    }
    return 'instagram://sharesheet?text=' + encoded;
  }

  function handleInstagramShare(swat, lid, shareUrl) {
    var copyFeedback = document.getElementById('swym-share-copy-feedback');

    if (!canUseInstagramNativeShare()) {
      handleInstagramShareFallback(swat, lid, shareUrl, copyFeedback);
      return;
    }

    // Mobile: native OS share picker (the standard pattern) — user picks
    // Instagram (opens its DM composer with the link), WhatsApp, etc.
    // Note: "Add to Story" only appears in the sheet for image/video files,
    // never for URLs, so a Stories-specific flow is not possible for links.
    var shareCopy = getWishlistShareCopy();
    if (navigator.share && typeof navigator.share === 'function') {
      navigator.share({
        title: shareCopy.title,
        text: shareCopy.text,
        url: shareUrl
      }).then(function() {
        trackInstagramShare(swat, lid);
        closeShareModal();
      }).catch(function(err) {
        if (err && err.name === 'AbortError') return;
        handleInstagramShareFallback(swat, lid, shareUrl, copyFeedback);
      });
      return;
    }

    // Rare: mobile browser without the Web Share API — deep link straight
    // into Instagram's composer, with the link on the clipboard as backup.
    copyShareUrl(shareUrl, null, null);
    trackInstagramShare(swat, lid);
    window.location.href = buildInstagramDeepLink(shareUrl);
    setTimeout(closeShareModal, 1200);
  }

  function handleInstagramShareFallback(swat, lid, shareUrl, feedbackEl) {
    copyShareUrl(shareUrl, feedbackEl, function() {
      trackInstagramShare(swat, lid);
      if (canUseInstagramNativeShare()) {
        window.location.href = 'https://www.instagram.com/create/story';
      } else {
        window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
      }
      setTimeout(closeShareModal, 1200);
    });
  }

  function handleSocialShare(swat, lid, platform, shareUrl) {
    if (platform === 'instagram') {
      handleInstagramShare(swat, lid, shareUrl);
      return;
    }

    var platformUrlTemplate = '';
    if (platform === 'facebook') platformUrlTemplate = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(shareUrl) + '&t=';
    else if (platform === 'twitter') platformUrlTemplate = 'https://twitter.com/share?text=&url=' + encodeURIComponent(shareUrl);
    swat.shareListSocial(lid, '', platformUrlTemplate, platform, '', function() {});
    if (platformUrlTemplate) window.open(platformUrlTemplate, '_blank', 'noopener,noreferrer');
    closeShareModal();
  }

  function showModalFeedback(el) {
    if (!el) return;
    setHidden(el, false);
    setTimeout(function() { setHidden(el, true); }, 2500);
  }

  function fallbackCopy(url, feedbackEl) {
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); showModalFeedback(feedbackEl); } catch (e) {}
    document.body.removeChild(ta);
  }

  function getSharedQueryParams(swat) {
    var params = Object.create(null);
    if (swat && swat.utils && typeof swat.utils.getEncodedAsObject === 'function') {
      params = swat.utils.getEncodedAsObject(window.location.search);
    } else {
      window.location.search.replace(/^\?/, '').split('&').forEach(function(pair) {
        if (!pair) return;
        var parts = pair.split('=');
        var key = decodeURIComponent(parts[0] || '');
        if (!key) return;
        params[key] = decodeURIComponent((parts[1] || '').replace(/\+/g, ' '));
      });
    }
    return params;
  }

  function getSharedListId(swat) {
    var params = getSharedQueryParams(swat);
    return params.hkey || params.lid || '';
  }

  function fetchSharedWishlistProducts(swat, lid, hkey, onSuccess, onError) {
    var sharedKey = hkey || lid;
    var fetchAttempts = [];

    if (typeof swat.fetchListDetails === 'function') {
      fetchAttempts.push(function(next) {
        swat.fetchListDetails({ lid: lid, hkey: sharedKey }, next, function() { next(null); });
      });
      fetchAttempts.push(function(next) {
        swat.fetchListDetails({ lid: lid }, next, function() { next(null); });
      });
      fetchAttempts.push(function(next) {
        swat.fetchListDetails({ hkey: sharedKey }, next, function() { next(null); });
      });
    }

    if (typeof swat.fetchListCtx === 'function') {
      fetchAttempts.push(function(next) {
        swat.fetchListCtx({ lid: lid, hkey: sharedKey }, next, function() { next(null); });
      });
      fetchAttempts.push(function(next) {
        swat.fetchListCtx({ lid: lid }, next, function() { next(null); });
      });
    }

    function runAttempt(index) {
      if (index >= fetchAttempts.length) {
        onError();
        return;
      }
      fetchAttempts[index](function(response) {
        if (response != null) {
          onSuccess(normalizeProductList(response));
          return;
        }
        runAttempt(index + 1);
      });
    }

    runAttempt(0);
  }

  function initSharedWishlistPage(swat) {
    var root = document.getElementById('swym-shared-wishlist-page');
    if (!root) return;
    if (root.dataset.swymSharedInit === 'true') return;
    root.dataset.swymSharedInit = 'true';

    var grid = document.getElementById('swym-shared-wishlist-grid');
    var loading = document.getElementById('swym-shared-wishlist-loading');
    var empty = document.getElementById('swym-shared-wishlist-empty');
    var error = document.getElementById('swym-shared-wishlist-error');
    if (!grid) return;

    var queryParams = getSharedQueryParams(swat);
    var lid = queryParams.lid || queryParams.hkey || '';
    var hkey = queryParams.hkey || queryParams.lid || '';
    if (!lid) {
      setHidden(loading, true);
      setHidden(error, false);
      return;
    }

    var finished = false;
    function finishWithError() {
      if (finished) return;
      finished = true;
      clearTimeout(timeoutId);
      setHidden(loading, true);
      setHidden(error, false);
    }

    function finishWithProducts(products) {
      if (finished) return;
      finished = true;
      clearTimeout(timeoutId);
      setHidden(loading, true);
      updateSectionCount(document.getElementById('swym-shared-wishlist-count'), products.length);
      renderProductGrid({
        swat: swat,
        mode: 'shared',
        products: products,
        container: grid,
        emptyEl: empty,
        sflLid: null,
        onProductsChange: null
      });
    }

    var timeoutId = setTimeout(finishWithError, 20000);

    fetchSharedWishlistProducts(swat, lid, hkey, finishWithProducts, function() {
      if (swat.ui && typeof swat.ui.renderSharedWishlistInContainer === 'function') {
        setHidden(loading, true);
        finished = true;
        clearTimeout(timeoutId);
        grid.innerHTML = '';
        grid.setAttribute('aria-busy', 'false');
        setHidden(empty, true);
        setHidden(error, true);
        try {
          swat.ui.renderSharedWishlistInContainer(grid, hkey, queryParams);
        } catch (e) {
          finishWithError();
        }
        return;
      }
      finishWithError();
    });
  }

  function runWithSwat(fn) {
    if (window._swat) {
      fn(window._swat);
      return;
    }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(fn);
  }

  function bootstrapSwymWishlistPages(swat) {
    if (document.getElementById('swym-shared-wishlist-page')) {
      initSharedWishlistPage(swat);
      return;
    }
    initWishlistPage(swat);
  }

  runWithSwat(bootstrapSwymWishlistPages);

  if (document.getElementById('swym-shared-wishlist-page')) {
    var sharedBootAttempts = 0;
    var sharedBootTimer = setInterval(function() {
      sharedBootAttempts += 1;
      if (window._swat) {
        clearInterval(sharedBootTimer);
        initSharedWishlistPage(window._swat);
      } else if (sharedBootAttempts >= 300) {
        clearInterval(sharedBootTimer);
        var loading = document.getElementById('swym-shared-wishlist-loading');
        var error = document.getElementById('swym-shared-wishlist-error');
        setHidden(loading, true);
        setHidden(error, false);
      }
    }, 100);
  }
})();
